module.exports = __webpack_public_path__ + "images/error_404_image.webp";